import { render } from "./TheoryPaperPractice.vue?vue&type=template&id=5abcf9da&scoped=true"
import script from "./TheoryPaperPractice.vue?vue&type=script&lang=js"
export * from "./TheoryPaperPractice.vue?vue&type=script&lang=js"

import "./TheoryPaperPractice.vue?vue&type=style&index=0&id=5abcf9da&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abcf9da"]])

export default __exports__